<template>
    <set-amazon-ws-credentials-dialog
        :value="value"
        @input="$emit('input', $event)"
        :loading="$wait.is('creatingAwsAccount')"
    >
        <template #activator="bindings">
            <slot name="activator" v-bind="bindings"></slot>
        </template>
        <template #actions="{ form, formId, isValid, clear, close }">
            <post-cloud-account-button
                :value="{ ...form, Type: 'Amazon' }"
                :clear="clear"
                :valid="isValid"
                :form="formId"
                v-wait-while="'creatingAwsAccount'"
                @http2xx="close().then(() => $emit('http2xx', $event))"
            ></post-cloud-account-button>
        </template>
    </set-amazon-ws-credentials-dialog>
</template>

<script>
import SetAmazonWsCredentialsDialog from '@/components/Settings.CloudAccounts/Amazon/SetAmazonWSCredentialsDialog';
import PostCloudAccountButton from '@/components/Settings.CloudAccounts/PostCloudAccountButton';
export default {
    components: { SetAmazonWsCredentialsDialog, PostCloudAccountButton },
    props: {
        value: Boolean,
    },
};
</script>
